import eventchain from '@/urls/eventchain'
import {
  sendGetRequest
} from '@/helper/requests'
import { SOCKET_BASE_HOST } from '@/helper/consts'
import { MESSAGES_TYPES } from '@/helper/socket'

/**
 * Класс обработчика сообщений WebSocket
 */
class EventHandlers {
  dispatch
  commit
  getters
  constructor ({ dispatch, commit, getters }) {
    this.dispatch = (...args) => dispatch(...args)
    this.commit = (...args) => commit(...args)
    this.getters = getters
  }

  [MESSAGES_TYPES.AUTH] ({ message, data }) {
    /**
     * Обрабатывает сообщения аутентификации
     * @param {Object} params - параметры сообщения
     * @param {string} params.message - тип сообщения
     * @param {Object} params.data - данные сообщения
     */
  }

  [MESSAGES_TYPES.NEW_EVENT] ({ message, data }) {
    /**
     * Обрабатывает новые события
     * @param {Object} params - параметры сообщения
     * @param {string} params.message - тип сообщения
     * @param {Object} params.data - данные сообщения
     */
    this.dispatch('addMessages', { val: data.data })
  }

  [MESSAGES_TYPES.OLD_MESSAGES] ({ message, data }) {
    /**
     * Обрабатывает старые сообщения
     * @param {Object} params - параметры сообщения
     * @param {string} params.message - тип сообщения
     * @param {Object} params.data - данные сообщения
     */
    this.dispatch('addOldMessages', { data: data.data })
  }

  [MESSAGES_TYPES.RECEIVE_MESSAGE] ({ message, data }) {
    /**
     * Обрабатывает получение сообщений
     * @param {Object} params - параметры сообщения
     * @param {string} params.message - тип сообщения
     * @param {Object} params.data - данные сообщения
     */
    console.log(data)
  }

  [MESSAGES_TYPES.REACTION_MESSAGE] ({ message, data }) {
    /**
     * Обрабатывает реакции на сообщения
     * @param {Object} params - параметры сообщения
     * @param {string} params.message - тип сообщения
     * @param {Object} params.data - данные сообщения
     */
    console.log(data)
  }

  [MESSAGES_TYPES.ACCEPT] ({ message, data }) {
    /**
     * Обрабатывает подтверждение подключения
     * @param {Object} params - параметры сообщения
     * @param {string} params.message - тип сообщения
     * @param {Object} params.data - данные сообщения
     */
    setInterval(() => {
      this.dispatch('heartbeatMessage', {})
    }, 60000);
  }

  [MESSAGES_TYPES.ERROR] ({ message, data }) {
    /**
     * Обрабатывает ошибки во время операций
     * @param {Object} params - параметры сообщения
     * @param {string} params.message - тип сообщения
     * @param {Object} params.data - данные сообщения
     */
    console.log(data)
  }
}

const state = {
  eventchain: {
    messages: [],
  }
}
const getters = {
  getMessages: (state) => state.eventchain.messages,
}

const actions = {
  connectJWT: ({ dispatch, commit, rootGetters }, { finalizer = () => {}, catcher = () => {} }) => {
    /**
     * Получает JWT токен для аутентификации в WebSocket
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры запроса
     * @param {Function} params.finalizer - функция обратного вызова при успехе
     * @param {Function} params.catcher - функция обратного вызова при ошибке
     */
    const url = eventchain.EVENT_CHAIN.JWT()
    sendGetRequest(
      url, (data, url) => {
        dispatch('socket/setToken', { token: data.token }, { root: true })
        // commit('socket/REPLACE_HANDLERS', new EventHandlers({ commit, dispatch, getters: rootGetters }), { root: true })
        finalizer(data, url)
      }, (data, url) => {
        catcher(data, url)
      }
    )
  },
  initEvent ({ commit, dispatch, getters, rootGetters }, url = null) {
    /**
     * Инициализирует подключение для получения сообщений
     * @param {Object} context - контекст Vuex
     * @param {string|null} url - URL WebSocket (опционально)
     */
    if (!rootGetters["socket/isInit"]) {
      dispatch('socket/init', {
        url: SOCKET_BASE_HOST + 'api/events/',
        handlers: new EventHandlers({ commit, dispatch, getters: rootGetters })
      }, { root: true })
    }
  },
  addMessages: ({ commit }, { val }) => {
    /**
     * Добавляет сообщения в цепочку событий, проверяя дубликаты
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры сообщения
     * @param {Object} params.val - объект сообщения
     */
    const searchNotification = state.eventchain.messages.find((item) => item.hash === val.hash)
    if (!searchNotification) { commit('ADD_MESSAGES', val) }
  },
  addOldMessages: ({ commit }, { data }) => {
    /**
     * Добавляет список старых событий
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры сообщений
     * @param {Array} params.data - массив старых сообщений
     */
    data.forEach((item) => {
      commit('ADD_MESSAGES', item)
    })
  },
  deleteMessages: ({ commit, dispatch }, { val }) => {
    /**
     * Удаляет сообщение по хешу и отправляет подтверждение
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры сообщения
     * @param {Object} params.val - объект сообщения для удаления
     */
    const filteredNotification = state.eventchain.messages.filter((item) => item.hash !== val.hash)
    commit('SET_MESSAGES', filteredNotification)

    dispatch('socket/sendMessages',
      {
        message: {
          type: MESSAGES_TYPES.RECEIVE_MESSAGE,
          event_id: val.id,
        }
      }, { root: true }
    )
  },
  heartbeatMessage: ({ commit, dispatch }, { val }) => {
    /**
     * Отправляет heartbeat для поддержания соединения
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры (не используются)
     */
    dispatch('socket/sendMessages',
      {
        message: {
          type: MESSAGES_TYPES.HEARTBEAT,
        },
      }, { root: true }
    )
  },
  deleteAllMessages: ({ commit, dispatch }, { val }) => {
    /**
     * Удаляет все сообщения и отправляет подтверждение
     * @param {Object} context - контекст Vuex
     * @param {Object} params - параметры (не используются)
     */
    commit('SET_MESSAGES', [])
    dispatch('socket/sendMessages',
      {
        message: {
          type: MESSAGES_TYPES.RECEIVE_ALL_MESSAGE,
        },
      }, { root: true }
    )
  },
}

const mutations = {
  SET_MESSAGES: (state, list) => {
    /**
     * Устанавливает список сообщений
     * @param {Object} state - состояние хранилища
     * @param {Array} list - массив сообщений
     */
    state.eventchain.messages = list
  },
  ADD_MESSAGES: (state, val) => {
    /**
     * Добавляет новое сообщение в начало списка
     * @param {Object} state - состояние хранилища
     * @param {Object} val - объект сообщения
     */
    state.eventchain.messages.unshift(val)
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
}
